"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.newTagSlug = exports.randHex = exports.randFloat = exports.randInt = exports.randomElement = void 0;
var slugify_1 = __importDefault(require("slugify"));
function randomElement(from) {
    return from[randInt(from.length - 1)];
}
exports.randomElement = randomElement;
function randInt(max) {
    if (max === void 0) { max = 10; }
    return Math.round(Math.random() * max);
}
exports.randInt = randInt;
function randFloat(max) {
    if (max === void 0) { max = 10; }
    return Math.random() * max;
}
exports.randFloat = randFloat;
function randHex(length) {
    if (length === void 0) { length = 32; }
    return "0x".concat(__spreadArray([], __read(Array(length)), false).map(function () { return Math.floor(Math.random() * 16).toString(16); }).join(''));
}
exports.randHex = randHex;
function newTagSlug(name) {
    return (0, slugify_1["default"])(name.replace(/[^\w]/g, '-'), { lower: true });
}
exports.newTagSlug = newTagSlug;
